<template>
  <div>
    <skeleton
      header-color="bg-cicinet-green"
      text-color="text-white"
      :mobile-navigation-breakpoint="mobileNavigationBreakpoint"
      :desktop-navigation-breakpoint="desktopNavigationBreakpoint"
    >
      <template slot="logo">
        <inertia-link href="/">Cicinet</inertia-link>
      </template>

      <template v-slot:userDropdownButton="{ toggleUserDropdown }">
        <button
          @click="toggleUserDropdown"
          class="flex items-center max-w-xs text-white focus:outline-none"
        >
          <i class="mr-2 fa fa-user fa-fw"></i>
          {{ $page.auth.user.name }} {{ $page.auth.user.last_name }}
        </button>
      </template>
      <template slot="userDropdownContent">
        <inertia-link
          :href="route('impersonate.leave')"
          class="block px-4 py-2 text-sm text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100"
          v-if="$page.auth.is_impersonating"
        >
          <i class="fas fa-user-secret fa-fw"></i>
          Končaj oponašanje
        </inertia-link>
        <inertia-link
          :href="route('users.editProfile', $page.auth.user.id)"
          class="block px-4 py-2 text-sm text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100"
        >
          <i class="fas fa-edit fa-fw"></i>
          Uredi profil
        </inertia-link>
        <inertia-link
          href="/logout"
          method="post"
          class="block px-4 py-2 text-sm text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100"
        >
          <i class="fas fa-sign-out-alt fa-fw"></i>
          Odjava
        </inertia-link>
      </template>
      <template slot="navigation">
        <navigation-item
          :to="route('home.index')"
          title="Prva stran"
          icon="fa-home"
          class="rounded-md"
        />
        <navigation-item
          :to="route('users.index')"
          title="Kontakti / Uporabniki"
          icon="fa-users"
          class="rounded-none"
          hover-class="hover:bg-transparent focus:bg-transparent hover:text-white"
        />
        <navigation-item
          :to="route('roles.index')"
          title="Enote / Skupine"
          icon="fa-tag"
          class="rounded-none"
          hover-class="hover:bg-transparent focus:bg-transparent hover:text-white"
          v-if="$page.auth.user.admin"
        />
        <navigation-item
          :to="route('folders.index')"
          title="Mape"
          icon="fa-folder"
          class="rounded-none"
          hover-class="hover:bg-transparent focus:bg-transparent hover:text-white"
          v-if="$page.auth.user.admin"
        />
        <navigation-item
          :to="route('calendar.index')"
          title="Koledar"
          icon="fa-calendar"
          class="rounded-none"
          hover-class="hover:bg-transparent focus:bg-transparent hover:text-white"
        />
        <navigation-item
          :to="route('notifications.index')"
          title="Okrožnice"
          icon="fa-bell"
          class="rounded-none"
          hover-class="hover:bg-transparent focus:bg-transparent hover:text-white"
        />
        <navigation-item
          :to="route('syndicate.index')"
          title="Sindikat"
          icon="fa-wrench"
          class="rounded-none"
          hover-class="hover:bg-transparent focus:bg-transparent hover:text-white"
        />
        <navigation-item
          :to="route('file-library.index')"
          title="Cici knjižnica"
          icon="fa-file-word"
          class="rounded-none"
          hover-class="hover:bg-transparent focus:bg-transparent hover:text-white"
        />
        <navigation-item
          :to="route('syndicate-file-library.index')"
          title="Sindikat knjižnica"
          icon="fa-file-word"
          class="rounded-none"
          hover-class="hover:bg-transparent focus:bg-transparent hover:text-white"
        />
        <navigation-item
          v-if="$page.auth.user.admin"
          :to="route('corporate-identity.index')"
          title="Celostna grafična podoba"
          icon="fa-id-card"
          class="rounded-none"
          hover-class="hover:bg-transparent focus:bg-transparent hover:text-white"
        />
        <a
          href="https://www.ciciban-nm.si/sl/za-otroke/starsevski-koticek"
          target="_blank"
          title="Starševski kotiček"
          class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-300 transition duration-150 ease-in-out group focus:outline-none hover:text-white hover:bg-gray-700 focus:text-white focus:bg-gray-700"
        >
          <i class="mr-2 fa fa-fw fa-globe"></i>
          <span>Cicigralnica</span>
        </a>
        <a
          :href="'https://glasovanje.odjava-obroka.si?email='+$page.auth.user.email"
          v-if="$page.auth.user.admin || $page.auth.user.voter"
          target="_blank"
          title="Glasovanje"
          class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-300 transition duration-150 ease-in-out group focus:outline-none hover:text-white hover:bg-gray-700 focus:text-white focus:bg-gray-700"
        >
          <i class="mr-2 fa fa-fw fa-globe"></i>
          <span>Glasovanje</span>
        </a>
        <a
          :href="'https://odjava-obroka.si/?email='+$page.auth.user.email"
          v-if="$page.auth.user.admin || $page.auth.user.canUnsubscribeFromMeal"
          target="_blank"
          title="Moja prehrana"
          class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-gray-300 transition duration-150 ease-in-out group focus:outline-none hover:text-white hover:bg-gray-700 focus:text-white focus:bg-gray-700"
        >
          <i class="mr-2 fa fa-fw fa-globe"></i>
          <span>Moja prehrana</span>
        </a>
      </template>
      <template>
        <div
          class="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-screen md:left-64 md:w-full-64"
          v-if="$store.state.isLoading"
        >
          <div class="absolute w-full h-full bg-white opacity-75"></div>
          <loading-spinner></loading-spinner>
        </div>
        <slot />
      </template>
    </skeleton>
    <portal-target name="modal" multiple></portal-target>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    mobileNavigationBreakpoint: {
      type: String,
      default: "md:hidden",
    },
    desktopNavigationBreakpoint: {
      type: String,
      default: "md:flex md:flex-shrink-0",
    },
  },
  data() {
    return {
      windowWidth: 0,
      baseTitle: "Cicinet",
    };
  },
  watch: {
    windowWidth(newWidth) {
      if (newWidth > 1024) {
        this.$store.commit("openNavigation");
      } else {
        this.$store.commit("closeNavigation");
      }
    },
    "$page.flash": {
      handler() {
        if (this.$page.flash.success) {
          this.$toast.open({
            message: this.$page.flash.success,
            type: "success",
          });
        } else if (this.$page.flash.error) {
          this.$toast.open({
            message: this.$page.flash.error,
            type: "error",
          });
        }
      },
      deep: true,
      immediate: true,
    },
    title: {
      immediate: true,
      handler(title) {
        if (this.title !== undefined) {
          document.title = this.baseTitle + " - " + title;
        } else {
          document.title = this.baseTitle;
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  },
};
</script>

<style lang="scss" scoped></style>
